<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zltszhfw/rzfw' }">认证认可</el-breadcrumb-item>
                    <el-breadcrumb-item>通知公告详情</el-breadcrumb-item>
                </el-breadcrumb>
                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <el-link :underline="false" @click="toPage('/main/index')"> 首页 </el-link>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="toPage('/main/zltszhfw/bzfw')"> 法律法规政策 </el-link>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router"> 详情</el-link>
                -->
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.title}}</h1>
            <el-row class="soure">
                <span style="padding-right: 15px;">发布时间：{{ parseTime(detail.fbTime, '{y}-{m}-{d}') }}</span><span style="padding-right: 15px;">访问量：{{browseCount}}</span><span>来源：{{fbDept}}</span>
            </el-row>
            <div v-html="detail.content" class="eidt-content"></div>
            <!--            <div style="align-content: center" align="center"><img src="../../../../assets/images/file_tmp/taishan_tzgg.png" style="width: 1000px"></img></div>-->
            <el-row class="row" v-if="detail.sysAttachments != '' && detail.sysAttachments != null">
                <el-col :span="24" align="left">
                    <div>附件：</div>
                    <div v-for="(item, index) in detail.sysAttachments":key="index" @click="handleDownload(item)" class="down">
                        <!--{{index+1}} 、--> {{item.fileName}}
                    </div>
                </el-col>
            </el-row>
        </el-row>

    </div>
</template>

<script>
    import {getBrowseCount} from "@/api/basedata/records";
    import {getStqytzgg} from "@/api/zlts/rzfw/stqytzgg";
    import {getTspztzgg} from "@/api/zlts/rzfw/tspztzgg";

    export default {
        name: "RzfwTzggDetail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid: undefined,
                type: undefined,
                detail: {},
                browseCount: undefined,
                fbDept: '威海市市场监督管理局',
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_zlts_rzfw_stqytzgg',
                },
            }
        },
        created() {
            this.recid = this.$route.query && this.$route.query.recid;
            this.getDetail();
        },
        methods: {
            toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh() {
                this.getDetail();
            },
            getDetail(){
                let recid = this.recid.split(':')[0];
                let tableName = this.recid.split(':')[1];
                if (tableName==='stqy'||recid==='stqy'){
                    getStqytzgg(recid).then(response => {
                        this.detail = response.data;
                    });
                }else if(tableName==='tspz'||recid==='tspz') {
                    getTspztzgg(recid).then(response => {
                        this.detail = response.data;
                    });
                }
                console.log("detail",this.detail)
                this.getBrowseData();
            },
            getBrowseData() {
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount = response;
                })
            },
            //下载附件
            handleDownload(file){
                var name = file.fileName;
                var url = file.path;
                const a = document.createElement('a');
                a.setAttribute('download', name);
                a.setAttribute('target', '_blank');
                a.setAttribute('href', process.env.VUE_APP_BASE_API+url);
                a.click();
            },
        }
    }
</script>

<style scoped>
    .app-container {
        padding: 0px 15px 20px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .content {
        border: 1px solid #cccccc;
        padding: 20px 80px;
    }

    .soure {
        background-color: #f3f3f3;
        padding: 10px;
        margin: 25px 0;
    }
    .down{
        cursor: pointer;
        margin-top: 1rem;
    }
    .down:hover{
        color: #2467d2;
    }
</style>